import { MinLength, IsNumberString } from 'class-validator';

export class AltaUsuario {
  Documento: string;
  @IsNumberString()
  Contrato: number;
  SerieFranumFra: string;
  @MinLength(3)
  CodExplotacion: string;
  ImporteUltimaFactura: number;
  ActualizarSiExiste: boolean;
}
